/**
 * The StockWise mark: three stacked cartons, the top one gold.
 *
 * Solid silhouettes with a single seam line each, rather than outlined boxes —
 * outlines close up and turn to mush once the icon is scaled to 16px in a
 * browser tab.
 *
 * The two plain cartons take `currentColor`, so the mark works on the dark
 * sidebar and on a light header without a second copy. The seam is drawn as
 * semi-transparent black *over* the opaque carton, which means it reads
 * correctly whatever colour that carton happens to be.
 *
 * The same geometry generates the favicon and PWA icons (see
 * client/scripts/generate-icons.mjs), so the mark in the app and the icon on a
 * home screen never drift apart.
 */

const CARTONS = [
  { x: 15, y: 7, gold: true },
  { x: 4, y: 26, gold: false },
  { x: 26, y: 26, gold: false },
];

const WIDTH = 18;
const HEIGHT = 15;
const SEAM_Y = 5.5;

export function BrandMark({ className = 'h-6 w-6', title }) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : 'true'}
      aria-label={title || undefined}
    >
      {title ? <title>{title}</title> : null}

      {CARTONS.map(({ x, y, gold }) => (
        <g key={`${x}-${y}`}>
          <rect
            x={x}
            y={y}
            width={WIDTH}
            height={HEIGHT}
            rx="2.5"
            fill={gold ? '#F59E0B' : 'currentColor'}
          />
          {/* Lid seam and flap join, dark enough to show on white and gold
              alike. Together they are what reads as "taped carton" rather
              than "rounded rectangle". */}
          <path
            d={`M${x} ${y + SEAM_Y} h${WIDTH}`}
            stroke="#000000"
            strokeOpacity="0.34"
            strokeWidth="2"
          />
          <path
            d={`M${x + WIDTH / 2} ${y} v${SEAM_Y}`}
            stroke="#000000"
            strokeOpacity="0.34"
            strokeWidth="2"
          />
        </g>
      ))}
    </svg>
  );
}

/** The mark in a filled tile, for headers and the sign-in panel. */
export function BrandBadge({ className = 'h-10 w-10', iconClassName = 'h-6 w-6' }) {
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-xl bg-neutral-900 text-white shadow-lg shadow-neutral-900/25 ${className}`}
    >
      <BrandMark className={iconClassName} />
    </div>
  );
}
